var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'thumbnail-upload-infinite': (!_vm.loaded && !_vm.loading) || _vm.processing,
    'thumbnail-upload-progress': _vm.loading && !_vm.processing,
  },style:(_vm.loading && !_vm.processing ? { 'background-size': (_vm.progress + "% 100%") } : {})},[_vm._t("default",null,{"loaded":_vm.loaded,"loading":_vm.loading,"processing":_vm.processing})],2)}
var staticRenderFns = []

export { render, staticRenderFns }